// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"458":"8b28764f","459":"12f9cb3c","674":"230d66b5","774":"d0f9c327","787":"ed513614","858":"70c012ea"}[chunkId] + ".chunk.js";
};